module.exports = __webpack_public_path__ + "img/sign-hanging.c8bfd3e9.svg";